export const ArtworkTypes = {
    IMAGE: 'IMG',
    VIDEO: 'VID'
}
